import { StockItemFragment } from "generated/graphql";

export const getMedicineWithdrawalsAsString = (withdrawal: StockItemFragment["withdrawal"]) => {
  if (!withdrawal || !withdrawal.length) return "";

  return withdrawal
    ?.map((item) => `${item?.animalType?.name}(${item?.withdrawalType}): ${item?.withdrawalPeriodDays} days`)
    .join(", ");
};
